import gql from 'graphql-tag';

// Hooks
import { useQuery } from '@apollo/react-hooks';

// Types
import { GetGateIdsQuery, GetGateIdsQueryVariables } from 'src/app/gql/__generated__/hooks';

export const GET_GATE_IDS = gql(`
  query getGateIds {
    gates {
        id
        name
    }
  }
`);

export const useGetGates = () => {
  const { data, loading, error } = useQuery<GetGateIdsQuery, GetGateIdsQueryVariables>(
    GET_GATE_IDS,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      onError: error => {
        console.error('Error fetching gates:', error);
      },
    }
  );

  return {
    gates: data?.gates || [],
    loading,
    error,
  };
};
